<template>
    <div class="grid-cols-4 gap-x-4 lg:grid">
        <div class="hidden flex-col col-span-1 space-y-8 lg:flex">
            <div v-for="image in images"
                 :key="`thumb-${image._uid}`"
                 class="relative cursor-pointer pt-full"
                 @click="onThumbClicked(image)">
                <img v-if="!(image.isVideo && !image.isYTVideo)"
                     :src="image.thumb"
                     :title="image.title"
                     :alt="image.alt"
                     class="object-contain object-center absolute top-0 left-0 w-full h-full bg-white">
                <div v-else class="absolute top-0 left-0 w-full h-full bg-black"></div>
                <icon v-if="image.isVideo" name="play" class="absolute top-0 left-0 p-8 w-full h-full" />
            </div>
        </div>
        <div class="hidden col-span-3 lg:block lg:h-113">
            <slot />
        </div>
        <slct-slider v-if="images.length > 1"
                     class="relative pb-8 lg:hidden"
                     slide-classes="w-full flex flex-col justify-center">
            <template v-for="image in images">
                <yt-video v-if="image.isVideo && image.isYTVideo" :key="image._uid" :video-id="image.ytId" :author="author">
                    <template #cookie-settings>
                        <slot name="cookie-settings"></slot>
                    </template>
                    <template #accept-cookies-settings>
                        <slot name="accept-cookies-settings"></slot>
                    </template>
                </yt-video>
                <video v-else-if="image.isVideo"
                       :src="image.image"
                       :key="image._uid"
                       class="object-contain w-full h-72"
                       preload="auto"
                       controls
                       playsinline
                       webkit-playsinline />
                <img v-else :key="image._uid" :src="image.image" class="object-contain w-full h-72">
            </template>
            <template #pagination="{ index, total, go, uid }">
                <div class="flex absolute bottom-0 justify-center w-full">
                    <div class="px-4 py-1.5 bg-opacity-80 rounded flex">
                        <div v-for="i in total" :key="uid + '_' + i" class=" p-1.5" @click="go(i - 1)">
                                <span class="block rounded-full w-1.5 h-1.5 bg-red transition-opacity"
                                      :class="{ 'opacity-30': i !== index }"></span>
                        </div>
                    </div>
                </div>
            </template>
        </slct-slider>
        <template v-else-if="images.length === 1">
            <video v-if="images[0].isVideo"
                   :src="images[0].image"
                   :key="images[0]._uid"
                   class="object-contain w-full h-72 lg:hidden"
                   preload="auto"
                   controls
                   playsinline
                   webkit-playsinline />
            <img v-else :src="images[0].image" class="object-contain w-full h-72 lg:hidden">
        </template>
    </div>
</template>

<script lang="ts">
import Vue from 'vue';
import { Component, Prop, Provide } from 'vue-property-decorator';
import ProductImage from './ProductImage.vue';
import Icon from './base/Icon.vue';

@Component({
    components: { Icon }
})
export default class ProductImages extends Vue {
    @Provide('registerProductImage') childRegistration = this.registerImage;

    @Prop({ default: false, type: Boolean }) author: boolean;

    images: ProductImage[] = [];

    registerImage(image: ProductImage) {
        this.images.push(image);
        if (this.images.length === 1) {
            this.images[0].active = true;
        }
    }

    onThumbClicked(image: ProductImage) {
        this.images.forEach(img => {
            img.active = false;
        });
        image.active = true;
    }
}
</script>
